import { Box } from "@mui/material"
import type { ColumnDef } from "@tanstack/react-table"
import React from "react"
import { twMerge } from "tailwind-merge"

import StyledChip from "@/components/common/Chip/Chip"
import type { Role } from "@/graphql/codegen/graphql"
import { RolesRowActions } from "@/screens/SystemAdmin/components"
import type { SystemAdminDialog } from "@/screens/SystemAdmin/types"

interface UseRolesColumnsProps {
  setSelectedRole: (role: Role) => void
  setDialogOpen: (open: SystemAdminDialog) => void
}

export const useRoleColumns = ({ setSelectedRole, setDialogOpen }: UseRolesColumnsProps): ColumnDef<Role>[] => {
  return [
    {
      accessorKey: "name",
      header: "Role",
      enableSorting: true,
    },
    {
      accessorKey: "permissions",
      header: "Permissions",
      enableSorting: false,
      cell: ({ row }): React.ReactElement => {
        const permissions = row.original?.permissions ?? []

        if (!permissions.length) {
          return <Box>-</Box>
        }
        return (
          <Box>
            {permissions.map((permission) => (
              <StyledChip
                size='small'
                key={`${row.original.roleId}-${permission?.permissionId}`}
                className={twMerge("m-1 rounded-s border-none text-xs text-gray-800")}
                classes={{
                  colorDefault: "bg-tertiary-yellow-300",
                }}
                variant='outlined'
                label={permission?.label}
              />
            ))}
          </Box>
        )
      },
    },
    {
      accessorKey: "actions",
      header: "",
      cell: ({ row }) => <RolesRowActions row={row} setSelectedRole={setSelectedRole} setDialogOpen={setDialogOpen} />,
      size: 30,
      enableSorting: false,
    },
  ]
}
